<template>
  <modal :modal-key="'achievement_in_progress_modal'"
         @close="$emit('close')"
         class="modal--welcomeback modal--zero-balance"
         :body-style="'achievement'">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_achievements_locked_title }} {{ achievementInfo.achievementLevelName }}</h1>
      <img class="pinicon" :src="achievementInfo.image" alt="">
    </template>
    <template slot="body">
      <h2 class="modal_sub">{{ getTranslations.home_modals_achievements_in_progress_title}}</h2>
      <div class="progress-barv2 modal_bar">
        <div class="bar" :data-size="achievementInfo.percentage">
          <span class="perc"></span>
        </div>
      </div>
      <p>
        {{ getTranslations.home_modals_achievements_locked_win }}
        {{ remaining }}
        {{ getTranslations.home_modals_achievements_locked_to_be_called }} "{{ achievementInfo.achievementLevelName }}"
      </p>
      <h2 class="modal_sub">{{ getTranslations.home_modals_achievements_locked_rewarded}}</h2>
      <achievement-reward :achievement-info="achievementInfo" :disable-play="true"/>
    </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import AchievementReward from '@/components/home/achievements/AchievementReward';
import { loading } from '@/common/jQuery';

export default {
  name: 'achievement-in-progress',
  props: {
    achievementInfo: Object,
  },
  mounted() {
    loading();
  },
  updated() {
    loading();
  },
  components: {
    Modal,
    AchievementReward,
  },
  computed: {
    remaining() {
      const { percentage, threshold } = this.achievementInfo;
      return Math.floor(threshold - ((percentage * threshold) / 100));
    },
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/AchievementInProgress.vue